export default "__VITE_ASSET__CUQ9iw8j__"